import { GridColDef } from '@mui/x-data-grid';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { StyledRolloverDataGrid } from '../styled';
import { buildDynamicColumns } from '../utils/utils';
import { PaperWrapper } from '../../common/styled';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

const RolloverStatusTable = ({
  rows,
  loading
}: {
  rows: any[];
  loading: boolean;
}) => {
  const columns = buildDynamicColumns(rows);

  const columnsToDisplay: GridColDef[] =
    tableColumnUtils.getColumnsToDisplay(columns);

  return (
    <PaperWrapper>
      <StyledRolloverDataGrid
        autoHeight
        rowHeight={50}
        rows={rows}
        columns={columnsToDisplay}
        getRowId={(row) => row.id || row['Enrollment Number']}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        loading={loading}
      />
    </PaperWrapper>
  );
};

export default RolloverStatusTable;
